// LOG 
// on 4-13-2023 se reparo el header de los items para que se vieran mejor usando el background nav
import React from 'react';
//import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {hasImage, sortObj,getSettings,siteCurrency,Image,Head} from './../../helpers';
import join from 'join-path';
import slugify from 'slugify';
const ItemsList = (props) =>{
    /* I HAVE TO REGISTER ALL ITEMS WITH SLUG NO ID */
   
    const parsePrice = siteCurrency("USD");
    const catBySlug = {};
    const cats = props.page['cats'] || {};
    const groups = props.page['groups'] || {};
    const items = props.page['items'] || {};
    const options = props.page['options'] || {};
    const page = props.params.page;
    const subpage =props.params.subpage || null;
    const firstcat =  cats["C000"].slug;
    const pageitem =props.params.item || null;
    const pgSlug = props.page.slug;
    let itemBySlug = {};
    const catname = "";
    var itemsByCat = Object.keys(cats).forEach(c =>{
        return <div value={c}>1 {c}</div>
    });
  
    const CatMod = Object.keys(cats).map(c =>{
            const slug = cats[c].slug;
            let  currCat = cats[c];
                 currCat.id = c;
            catBySlug[slug] = currCat;
            let pageLink = `/${pgSlug}/`+slug;
            let icon ="selected";
            if(subpage===slug){
                icon = "";
            }
            if(cats[c].name ==="") return null;
            return <Link to={pageLink}  className={`catalog-tab ${icon}`}>
                <div key={c}>
                    <strong>{cats[c].name}</strong>
                </div>
            </Link>
          
          
    });
    const ItemsByGroupObj = (group)=>{
        let itemsByG ={};
        Object.keys(items).map(itm =>{
            const item = items[itm];
            if(item.group === group){
                itemsByG[itm]=item;
            }
        });
        return itemsByG;
    }
    const getOptionData = (option)=>{
        if(typeof option==="string"){
            let option_r =options[option];
                option_r["id"] = option;
            return option_r;
        }
        return {};
    }
     // need to fix sale price replace the orignal price with differnt color   
    const ItemsByGroup = (group, group_name)=>{
        return Object.keys(items).map(itm =>{
            const item = items[itm];
            const item_slug = slugify(item.name.toLowerCase(), {remove: /[*+~.()'"!:@]/g});
            const item_price = parsePrice((item.sale_price)? item.sale_price : item.price);
            itemBySlug[item_slug.replace("-","_")] = itm;
            if(item.group === group){
                const linkToItem = `/${page}/${subpage}/${slugify(group_name.toLowerCase())}/${item_slug}`;
                // to activate the link just add this tags <Link key={itm} to={linkToItem}>
                return  <div className="catalog-item" key={itm}>
                        <div className="item-wrap">
                        <div className="item-image"><img src={Image(item.image)}/></div>
                        <div className="item-name"><h2>{item.name}</h2></div>
                        <div className="item-price"><p>{item_price}</p></div>
                        <div className="item-description"><p>{item.description}</p></div>
                        <div className="clear"></div>
                    </div>
                </div>
            }
           
        });
    }
    let gs = [];
    var maxGroups = 11;
    for (var i = 0; i < maxGroups; i++) {
        gs.push('group_'+i);
        //Do something
    }
    const GroupsMod = gs.map(g =>{
        if(typeof catBySlug[subpage] ==='object'){
            if(!catBySlug[subpage].hasOwnProperty(g)) return false;
            const group =catBySlug[subpage][g];
            const catname = catBySlug[subpage].name ||"";
            if(typeof groups[group]==="object"){
                const groupname = groups[group].name;
                return <div key={g}>
                    <div className="catalog-group">{catname} > {groupname}</div>
                    <div className="catalog-item-wrap">{ItemsByGroup(group, groups[group].name)}</div>
                </div>
            }else{
                return null;
            }
        }
    });
    if(pageitem){
        /*********** ITEM TEMPLATE  **************/
        /* ITEMS BY GROUP JSON.stringify(ItemsByGroupObj(item.group)) */
        const  id= itemBySlug[pageitem.replace("-","_")];
        const  link = `/${page}/${subpage}`;
        const  item = items[id]; // HERE I HAVE TO ADD FUNCTION TO RETUNR ITEM INFO BY SLUG
        if(!item) return <div>item not found</div>
        return <div className="hero is-fullheight is-white">
        <div className="section item-page">
            <div className="container">
                <h1>{item.name}</h1>
                <img src={Image(item.image)} width="200px"/>
                <h3>GO BACK LINK</h3>
                {JSON.stringify(options[item.option])}
                <b>DATA</b><br />
                Option: {item.option}<br />
                Goback:{link}<br />
                ITEM_GROUP:{item.group}<br />
                OPTION 1:{JSON.stringify(getOptionData(item.option_1))}<br />
                OPTION 2:{JSON.stringify(getOptionData(item.option_2))}<br />
                OPTION 3:{JSON.stringify(getOptionData(item.option_3))}<br />
                OPTION 4:{JSON.stringify(getOptionData(item.option_4))}<br />
                <b>GROUP</b><br />
                <b>ITEM</b><br />
                {JSON.stringify(item)}<br />
            </div>
            </div>
        </div>
    }else{
        if(subpage===null){
            window.location =`${page}/${firstcat}`;
        }
        return <div className="hero is-fullheight is-white">
        <div className="section">
            <div className="container">
                <div className='catalog-tabs'>
                    {CatMod}
                </div>
                <div className="catalog-items">
                    {GroupsMod}
                </div>
            </div>
            </div>
        </div>
    }
  

}
export default ItemsList;
// <div className="catalog-header">
//<h2 className="title is-3">{catalog('name')} {subpage } {page}</h2>
//</div>
///


// WEBPACK FOOTER //
// ./src/components/themes/Catalog.js